import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectEntityMap } from '@core/state/entities/entity.selectors';
import { IInvitation } from '@core/state/entities/invitation/invitation.entity';

export const selectInvitationMapByToken = createSelector(
  selectEntityMap('invitationSecureDetails'),
  selectEntityMap('invitations'),
  (secureDetailsMap, invitationMap) =>
    Object.entries(secureDetailsMap).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [value.token]: invitationMap[key],
      }),
      {} as { [token: string]: IInvitation }
    )
);
